import { Component, Input,  } from '@angular/core';
import { TransportCounts } from '../../../../../common/model/transport.model';



@Component({
  selector: 'app-transport-counts',
  templateUrl: './transport-counts.component.html',
  styleUrls: ['./transport-counts.component.scss']
})
export class TransportCountsComponent  {

  @Input() counts: TransportCounts;

  constructor() {}

}
